var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_85237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_958_85237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_958_85237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_958_85237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_958_85237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17676 15.4847L7.35108 14.2689L9.9585 16.7852L12.6457 14.1899L13.8216 15.4066L10.7869 18.3371L9.98698 19.1663L6.17676 15.4847ZM13.4766 13.2907C13.4765 13.1032 13.4987 12.9164 13.5425 12.734L12.8141 12.2238L10.2539 13.451V9.92887L13.4758 8.38428V11.3384L14.0527 11.742C14.4161 11.3207 14.9157 11.0403 15.4647 10.9502C16.0137 10.86 16.5767 10.9658 17.0557 11.2489C17.5347 11.5319 17.8992 11.9745 18.0851 12.4989C18.271 13.0233 18.2667 13.596 18.0729 14.1175C17.8792 14.6391 17.5088 15.0762 17.0256 15.352C16.5424 15.6279 15.9773 15.7255 15.4297 15.6271C14.8821 15.5287 14.3861 15.2409 14.0291 14.8141C13.6721 14.3874 13.4767 13.8487 13.4766 13.2923V13.2907ZM1.77735 13.2915C1.77756 12.8194 1.91889 12.3581 2.18262 11.9666C2.44634 11.5751 2.82027 11.271 3.25765 11.0934C3.69503 10.9158 4.17585 10.8729 4.63786 10.9697C5.09987 11.0666 5.52282 11.2987 5.85205 11.637L6.52263 11.1675V8.38428L9.74447 9.92887V13.451L7.03939 12.1554L6.41764 12.5908C6.51898 12.9173 6.54806 13.2617 6.50391 13.6007C6.45976 13.9397 6.34288 14.2649 6.1613 14.5545C5.97971 14.8442 5.73836 15.0914 5.45248 15.2788C5.16659 15.4663 4.84324 15.5899 4.50521 15.6409C4.16718 15.692 3.82215 15.6689 3.49365 15.5742C3.16516 15.4796 2.86076 15.3155 2.60173 15.0924C2.3427 14.8693 2.13531 14.5927 1.993 14.2819C1.8507 13.9711 1.77696 13.6334 1.77735 13.2915ZM15.769 9.96305V4.16634H13.269V2.49967H17.4357V9.96387L15.769 9.96305ZM2.50082 9.96305V2.49967H6.66748V4.16634H4.16748V9.96142L2.50082 9.96305ZM6.85547 7.97982L9.44417 6.73796V5.514C8.87933 5.37811 8.38383 5.03937 8.05176 4.56266C7.71969 4.08596 7.57411 3.50386 7.64242 2.92692C7.71072 2.34999 7.98865 1.81877 8.42285 1.43278C8.85706 1.04679 9.41741 0.83324 9.99837 0.833008C10.5797 0.833002 11.1411 1.0465 11.5755 1.43278C12.01 1.81906 12.2871 2.35119 12.3551 2.92855C12.4232 3.50591 12.277 4.08842 11.9442 4.5651C11.6114 5.04179 11.1156 5.37968 10.5501 5.51481V6.73796L13.1396 7.979L9.99919 9.48535L6.85547 7.97982Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_85237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockchain);
export default __webpack_public_path__ + "static/media/icon-blockchain.99af0f7e0b01aaf918ecc0cc6478f7cd.svg";
export { ForwardRef as ReactComponent };